import { HeaderProps, MenuProps } from "../types";
import MarketIcon from "../../assets/header/nav/market.svg?react";
import FuturesMainIcon from "../../assets/header/nav/futures-main.svg?react";
import SpotIcon from "../../assets/header/nav/spot.svg?react";
import CopyTradingIcon from "../../assets/header/nav/copy-trading.svg?react";
// import EarnIcon from "../../assets/header/nav/earn.svg?react";
import MoreIcon from "../../assets/header/nav/more.svg?react";
import ActivityIcon from "../../assets/header/nav/activity.svg?react";
import AffiliatesIcon from "../../assets/header/nav/affiliates.svg?react";
import BonusIcon from "../../assets/header/nav/bonus.svg?react";
import BotsIcon from "../../assets/header/nav/bots.svg?react";
import FuturesIcon from "../../assets/header/nav/futures.svg?react";
import ReferralIcon from "../../assets/header/nav/referral.svg?react";
import DemoIcon from "../../assets/header/nav/demo.svg?react";
import LeaderBoardIcon from "../../assets/header/nav/leader-board.svg?react";
import AllTradersIcon from "../../assets/header/nav/all-traders.svg?react";
import ApplicationIcon from "../../assets/header/nav/application.svg?react";
// import ActivityLight from "../../assets/header/activity-light.svg?react";
// import ActivityDark from "../../assets/header/activity-dark.svg?react";
import Cookies from "js-cookie";
import { useTranslations } from "use-intl";
import Hot from "../Hot";
import { useDispatch, useStoreState } from "../store/useStore";
import Menu from "./Menu";
import { FC, useEffect, useMemo, useState } from "react";
import { activeRouteStyles, stylesText } from "../styles";
import { Drawer } from "@blofin/blofin-ui";
import H5Menu from "./H5Menu";
import useDemoTradingListen from "../hooks/useDemoTradingListen";
import useColor from "../hooks/useColor";
import { getCurrentPath } from "./getActiveClass";

const Nav: FC<HeaderProps> = (props) => {
  const t = useTranslations("header");

  const {
    localeLink,
    drawerOpen,
    position,
    isLogin,
    theme,
    userInfo,
    baseUrl,
    hideAcitvityLogo,
    isDemoTrading,
    env
  } = useStoreState();

  const { dispatch } = useDispatch();

  const { changeRoute } = props;

  const { triggerDemoTradingChange } = useDemoTradingListen();

  const { isUk } = useColor(baseUrl, env);

  const filterNavByKey = (nav: MenuProps[], key: keyof MenuProps, isExclude = false) => {
    return nav
      .map((item) => {
        if (item.type === "menu" && item.items) {
          return {
            ...item,
            items: item.items.filter((subItem) => (isExclude ? !subItem[key] : subItem[key]))
          };
        }
        return item;
      })
      .filter((item) => (isExclude ? !item[key] : item[key]));
  };

  const navs = useMemo(() => {
    let navs: MenuProps[] = [
      {
        type: "link",
        label: "market",
        url: `${localeLink}/market/derivatives`,
        activeRouts: ["/market", "/market/derivatives", "/market/favorites", "/market/spot"],
        icon: MarketIcon,
        isSupportSubAccount: true
      },
      {
        type: "link",
        label: "spot",
        url: `/spot${localeLink}/BTC-USDT`,
        activeRouts: ["/spot/[marketID]"],
        icon: SpotIcon,
        isSupportDemoTrading: true,
        isSupportSubAccount: true
      },
      {
        type: "menu",
        label: "futures",
        activeRouts: ["/futures/[marketID]"],
        drawer: false,
        icon: FuturesMainIcon,
        isSupportDemoTrading: true,
        isSupportSubAccount: true,
        items: [
          {
            label: "futures",
            url: `BTC-USDT`,
            des: "futuresDes",
            icon: FuturesIcon,
            basePath: "futures",
            isSupportDemoTrading: true,
            isSupportSubAccount: true
          },
          {
            label: "bots",
            url: `BTC-USDT?mode=tools`,
            des: "botsDes",
            icon: BotsIcon,
            basePath: "futures",
            isSupportDemoTrading: true,
            clickFunc: (e) => {
              e.stopPropagation();
              e.preventDefault();
              sessionStorage.removeItem("global-role");
              setTimeout(() => {
                window.location.href = `/futures${localeLink}/BTC-USDT?mode=tools`;
              }, 100);
            }
          },
          {
            label: "demoTrading",
            url: `BTC-USDT`,
            des: "demoTradingDesc1",
            icon: DemoIcon,
            basePath: "futures",
            // hotText: t("tryUtaNow"),
            clickFunc: (e) => {
              e.stopPropagation();
              e.preventDefault();
              sessionStorage.removeItem("global-role");
              triggerDemoTradingChange(true);

              if (!isLogin) {
                window.location.href = `${localeLink}/login?isDemoTrading=1&redirect=${encodeURIComponent(
                  `/futures${localeLink}/BTC-USDT`
                )}`;
                return;
              }
              Cookies.set("Global-UserViewType", "demo-trading", { expires: 365 });
              setTimeout(() => {
                if (
                  window.location.pathname.includes("futures") ||
                  window.location.pathname.includes("/activity")
                ) {
                  window.location.reload();
                } else {
                  window.location.href = `/futures${localeLink}/BTC-USDT`;
                }
              }, 100);
            }
          }
        ]
      },
      {
        type: "link",
        label: "copyTrading",
        // url: `${localeLink}/copy-trade`,
        icon: CopyTradingIcon,
        activeRouts: [
          "/copy-trade",
          "/copy-trade/leader",
          "/copy-trade/follower",
          "/copy-trade/assets",
          "/copy-trade/application",
          "/copy-trade/details",
          "/copy-trade/details/[leaderID]"
        ],
        items: [
          {
            label: "leaderBoard",
            url: "copy-trade?tab=leaderboard",
            des: "leaderBoardDes",
            icon: LeaderBoardIcon
          },
          {
            label: "allTraders",
            url: "copy-trade?tab=allTraders",
            des: "allTradersDes",
            icon: AllTradersIcon
          },
          {
            label: "eliteTradersRecruitment",
            url: "copy-trade/application",
            des: "eliteTradersRecruitmentDes",
            icon: ApplicationIcon
          }
        ]
      },
      // {
      //   type: "link",
      //   label: "earn",
      //   url: `${localeLink}/earn`,
      //   activeRouts: ["/earn", "/earn/my"],
      //   icon: EarnIcon
      // },
      {
        type: "link",
        label: "welcomeBonus",
        url: `${localeLink}/task-center`,
        activeRouts: ["/task-center"],
        icon: BonusIcon
      },
      {
        type: "menu",
        label: "more",
        drawer: false,
        icon: MoreIcon,
        isSupportSubAccount: true,
        isSupportDemoTrading: true,
        activeRouts: [
          "/activity",
          "/activity/competition/[activityID]",
          "/activity/details/[50]",
          "/activity/details/[51]",
          "/activity/regular/[activityID]",
          "/affiliates",
          "/referral",
          "/ambassador"
        ],
        items: [
          {
            label: "activity",
            url: "",
            des: "activityDes",
            basePath: "activity",
            icon: ActivityIcon,
            isSupportDemoTrading: true
          },
          {
            label: "affiliates",
            url: "affiliates",
            des: "affiliatesDes",
            icon: AffiliatesIcon
          },
          {
            label: "referral",
            url: "referral",
            des: "referralDes",
            icon: ReferralIcon,
            isExcludeUk: true
          }
          // {
          //   label: 'ambassador',
          //   url: 'ambassador',
          //   des: 'ambassadorDes',
          //   icon: AmbassadorIcon
          // }
        ]
      }
      // {
      //   noH5: true,
      //   type: "img",
      //   label: "",
      //   url: `/activity${localeLink}/competition/league/1102`,
      //   src:
      //     theme !== "dark" ? (
      //       <ActivityLight className="ml-[-8px] w-[120px] h-[42px]" />
      //     ) : (
      //       <ActivityDark className="ml-[-8px] w-[120px] h-[42px]" />
      //     )
      // }
    ];
    if (isUk) {
      navs = filterNavByKey(navs, "isExcludeUk", true);
    }

    const isDemoTrading = Cookies.get("Global-UserViewType") === "demo-trading";

    if (isDemoTrading) {
      navs = filterNavByKey(navs, "isSupportDemoTrading");
    }

    const cookieAccountType = Cookies.get("Global-AccountType");

    if (
      cookieAccountType === "NORMAL_SUB_ACCOUNT" ||
      userInfo?.account_type === "NORMAL_SUB_ACCOUNT"
    ) {
      navs = filterNavByKey(navs, "isSupportSubAccount");
    }

    return navs;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localeLink, t, isUk, userInfo?.account_type, triggerDemoTradingChange, isLogin, theme]);

  const [pages, setPages] = useState<MenuProps[]>(isDemoTrading ? [] : navs);

  useEffect(() => {
    setPages(navs);
  }, [navs]);

  const mode = useMemo(() => {
    if (position === "sticky") {
      return "light";
    } else {
      return theme;
    }
  }, [position, theme]);

  const changeRouter = (item: MenuProps, e: React.MouseEvent<HTMLAnchorElement>) => {
    if (changeRoute) {
      e.preventDefault();
      if (!item.items) {
        changeRoute(item.url as string);
      }
    }
  };

  const changePages = (label: string) => {
    setPages((pre) => {
      return pre.map((item) => {
        if (item.label === label) {
          return {
            ...item,
            drawer: !item.drawer
          };
        }
        return item;
      });
    });
  };

  return (
    <div>
      <ul className="min-[1000px]:flex min-[1000px]:items-center max-[1000px]:hidden">
        {pages.map((item, index) => {
          return (
            <li key={index} className="ml-[24px] h-[64px] flex items-center relative">
              {item.items ? (
                <Menu menus={item} changeRoute={changeRoute} />
              ) : (
                <a href={`${item.url}`} onClick={(e) => changeRouter(item, e)}>
                  <span
                    className={`text-[14px] flex items-center font-normal ${
                      getCurrentPath(item.activeRouts)
                        ? activeRouteStyles({
                            mode: theme
                          })
                        : ""
                    } ${stylesText({
                      mode: theme
                    })}`}
                  >
                    {item.label && t(item.label)}
                    {item.hot && <Hot theme={theme} />}
                    {!hideAcitvityLogo && item.type === "img" && item.src}
                  </span>
                </a>
              )}
            </li>
          );
        })}
      </ul>
      <Drawer
        title=""
        placement="right"
        content={
          <div>
            <ul className="flex flex-col">
              {pages.map((item, index) => {
                return (
                  <li
                    key={index}
                    className={`${
                      item.items ? " mb-[24px]" : " mb-[32px]"
                    } min-h-[24px] flex items-center relative`}
                  >
                    {item.items ? (
                      <H5Menu menus={item} changeRoute={changeRoute} changePages={changePages} />
                    ) : (
                      <a href={`${item.url}`} onClick={(e) => changeRouter(item, e)}>
                        <span
                          className={`text-[16px] flex items-center font-normal ${stylesText({
                            mode: mode
                          })}`}
                        >
                          {item.icon && <item.icon className={stylesText({ mode: mode })} />}
                          {item.label !== "" && (
                            <i className="ml-[12px] not-italic"> {t(item.label)}</i>
                          )}
                        </span>
                      </a>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        }
        drawerContentClass="w-[376px] max-[600px]:w-full"
        open={drawerOpen}
        cancel={() => dispatch({ type: "SET_DRAWEROPEN", payload: false })}
      />
    </div>
  );
};

export default Nav;
